/**
 * TGH Senior Center — Locations list + map
 * Filters list by search query, manages map pin visibility, handles interactions
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    document.querySelectorAll('[data-tgh-loc-list-root]').forEach(function (root) {
      if (root.dataset.tghReady) return;
      root.dataset.tghReady = '1';

      var list = root.querySelector('[data-tgh-loc-list]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-tgh-loc]'));
      var empty = root.querySelector('[data-tgh-loc-empty]');
      var form = list && document.querySelector('[data-tgh-loc-search="' + list.id + '"]');
      var flashTimer = 0;

      function setActive(slug) {
        items.forEach(function (item) { item.classList.toggle('is-active', item.getAttribute('data-tgh-loc') === slug); });
      }

      /* ---- map ↔ list ---- */
      items.forEach(function (item) {
        var slug = item.getAttribute('data-tgh-loc');
        var on = function () {
          window.clearTimeout(flashTimer);
          setActive(slug);
          if (window.TGHMap) window.TGHMap.setMarkerActive(slug);
        };
        var off = function () {
          setActive(null);
          if (window.TGHMap) window.TGHMap.setMarkerInactive();
        };
        item.addEventListener('mouseenter', on);
        item.addEventListener('mouseleave', off);
        item.addEventListener('focusin', on);
        item.addEventListener('focusout', function (event) { if (!item.contains(event.relatedTarget)) off(); });
      });

      /* ---- search ---- */
      if (!form) return;
      var input = form.querySelector('input');
      var status = form.querySelector('[data-tgh-loc-status]');
      var debounce = 0;

      function filter(query, announce) {
        var q = query.trim().toLowerCase();
        var shown = 0;
        items.forEach(function (item) {
          var match = !q || (item.getAttribute('data-search') || item.textContent).toLowerCase().indexOf(q) !== -1;
          item.hidden = !match;
          var slug = item.getAttribute('data-tgh-loc');
          if (window.TGHMap) {
            if (match) window.TGHMap.showMarker(slug);
            else window.TGHMap.hideMarker(slug);
          }
          if (match) shown++;
        });
        if (empty) empty.hidden = shown !== 0;
        if (status) {
          status.textContent = !q ? '' : shown === 0
            ? 'No locations match "' + query.trim() + '".'
            : (announce ? shown + (shown === 1 ? ' location found.' : ' locations found.') : '');
          status.classList.toggle('tgh-visually-hidden', shown !== 0);
        }
        return shown;
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var query = input.value.trim();

        if (!query) {
          filter('', false);
          return;
        }

        // Check if it looks like an address (contains ZIP code pattern or common address keywords)
        var isAddress = /^\d{5}|,|avenue|drive|street|rd|dr|ave|st|lane|ln|circle|court|ct|way|road/.test(query.toLowerCase());

        if (isAddress && window.TGHMap && window.TGHMap.geocodeAddress) {
          // Perform geocoding-based search
          status.textContent = 'Searching...';
          status.classList.remove('tgh-visually-hidden');

          window.TGHMap.geocodeAddress(query, function (err, coords) {
            if (err) {
              status.textContent = 'We couldn\'t find that location. Try a ZIP code or city, or call us at (813) 725-1725.';
              status.classList.remove('tgh-visually-hidden');
              filter('', false);
              return;
            }

            // Center map on the geocoded location
            window.TGHMap.panTo(coords.lat, coords.lng, 11);

            // Get distances from the found location to all TGH locations
            window.TGHMap.getDistances(coords, window.TGHMap.getAllLocations(), function (err, result) {
              if (err) {
                status.textContent = 'Error calculating distances. Please try again.';
                status.classList.remove('tgh-visually-hidden');
                return;
              }

              // Sort items by distance
              var distances = result.rows[0].elements;
              var locSlugs = Object.keys(window.TGHMap.getAllLocations());

              var itemsWithDistance = items.map(function (item, index) {
                var dist = distances[index].distance;
                return {
                  item: item,
                  distance: dist ? dist.value : Infinity,
                  slug: locSlugs[index]
                };
              });

              itemsWithDistance.sort(function (a, b) {
                return a.distance - b.distance;
              });

              // Reorder items in the DOM
              itemsWithDistance.forEach(function (data) {
                list.appendChild(data.item);
              });

              // Update items array order to match new DOM order
              items.length = 0;
              itemsWithDistance.forEach(function (data) {
                items.push(data.item);
              });

              // Show all items (no text filtering)
              items.forEach(function (item) {
                item.hidden = false;
                var slug = item.getAttribute('data-tgh-loc');
                if (window.TGHMap) window.TGHMap.showMarker(slug);
              });

              status.textContent = items.length + (items.length === 1 ? ' location found.' : ' locations found.');
              status.classList.remove('tgh-visually-hidden');

              // Scroll to first item
              if (items[0]) items[0].scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
            });
          });
        } else {
          // Perform text-based filtering (ZIP code, city name in search data)
          if (filter(query, true) && query) {
            var first = items.filter(function (item) { return !item.hidden; })[0];
            if (first) first.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
          }
        }
      });

      input.addEventListener('input', function () {
        window.clearTimeout(debounce);
        debounce = window.setTimeout(function () { filter(input.value, true); }, 250);
      });

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && input.value) {
          input.value = '';
          filter('', false);
          status.textContent = '';
          status.classList.add('tgh-visually-hidden');

          // Reset map to default center
          if (window.TGHMap) {
            window.TGHMap.panTo(28.0, -82.5, 10);
          }
        }
      });

      // Deep link: /locations/?q=33511
      var initial = new URLSearchParams(window.location.search).get('q');
      if (initial) { input.value = initial; filter(initial, true); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();



// WEBPACK FOOTER //
// ./assets/js/modules/locations-list.js